import ShouldDelayFocus from './types';

const shouldDelayFocus: ShouldDelayFocus = false;

export default shouldDelayFocus;
